import { BatchUpdateCartBody } from '@diamond/shared/types';
import { useMutation } from '@tanstack/react-query';

import { patchBatchCart } from '../queries';
import { useAuthStore, useShipToStore } from '../stores';

export function useUpdateBatchCart({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}) {
  const token = useAuthStore((s) => s.access_token);
  const warehouse = useShipToStore((s) => s.selectedShipToId);
  return useMutation({
    mutationFn: (products: BatchUpdateCartBody) =>
      patchBatchCart(token, warehouse, products),
    onSuccess,
    onError,
  });
}
